import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import PropTypes from 'prop-types';
import React, { memo } from 'react';

function ContextConnectedComponent(_ref) {
  var Component = _ref.Component,
      props = _objectWithoutPropertiesLoose(_ref, ["Component"]);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(Component, props)
  );
}

ContextConnectedComponent.propTypes = {
  Component: PropTypes.elementType.isRequired
};
export default memo(ContextConnectedComponent);